import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

//components
import withLocalization from '../../../hoc/withLocalization';

//elements
import Select from '../../../elements/Select';

const PmReassignmentInner = inject('userStore')(withLocalization(observer(class PmReassignmentInner extends Component {
    componentDidMount() {
        const { userStore } = this.props;
        if (!userStore.pmLists.length) userStore.lookupPms();
    }

    renderTransferInfo() {
        const { t } = this.props;
        return (
            <OverlayTrigger
                placement="left"
                overlay={
                    <Tooltip id="tooltip-pm-reassignment">
                        <div className="text-start">
                            <div>{t('On the end date the following is transferred to the selected PM')}:</div>
                            <div>{`• ${t('Projects')}`}</div>
                            <div>{`• ${t('Tasks')}`}</div>
                            <div>{`• ${t('Employees')}`}</div>
                            <div>{`• ${t('Groups')}`}</div>
                            <div>{`• ${t('Permissions')} (${t('combined with the new PM, duplicates removed')})`}</div>
                        </div>
                    </Tooltip>
                }
            >
                <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
            </OverlayTrigger>
        );
    }

    render() {
        const { t, value, onChange, userStore, schema } = this.props;
        const { pmLists, currentEntity } = userStore;
        const currentPmId = currentEntity?.user?.id;

        //a PM who is leaving themselves cannot take over the departing PM's employees//
        const options = pmLists.filter(pm => pm.value !== currentPmId && !pm.timelog_end_at);
        const isDisabled = !!schema?.readOnly;

        return (
            <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                    <Select
                        options={options}
                        value={options.find(o => o.value === value) || null}
                        isDisabled={isDisabled}
                        onChange={opt => onChange(opt ? opt.value : null)}
                        placeholder={t('Select PM')}
                        style={{ width: '100%' }}
                    />
                </div>
                {this.renderTransferInfo()}
            </div>
        );
    }
})));

export const PmReassignmentWidget = observer(class PmReassignmentWidget extends Component {
    render() {
        return <PmReassignmentInner {...this.props} />;
    }
});
